<ng-container *ngIf="model">
  <span
    (click)="$event.stopPropagation(); openPreview()"
    class="person"
    [ngClass]="{ 'is-me': isMe }"
    #person
    [innerHTML]="'@' + model.text | highlight: highlights:highlightStyle"
  ></span>
</ng-container>
